import React, { useState } from 'react';

import { Select } from '@aline/common';
import { MenuItem } from '@mui/material';
import { ToolbarInput, ToolbarSelect } from 'src/components';
import type { Apollo } from 'src/gql/generated';

interface DefaultAnswerProps extends React.HTMLAttributes<HTMLElement> {
  onChangeAnswer: (defaultAnswer: UUID | number) => void;
  options: Apollo.AnswerOptionProps[];
  value: UUID | number;
  disabled?: boolean;
}

export function DefaultAnswer(props: DefaultAnswerProps): JSX.Element {
  const { className, disabled, onChangeAnswer, options, value } = props;
  const [selectOpen, setSelectOpen] = useState<boolean>(false);
  const selectedOption =
    typeof value === 'number'
      ? options[value]
      : (options.find(option => option.id === value) ?? null);

  return (
    <ToolbarSelect
      MenuProps={{
        anchorOrigin: {
          horizontal: 'right',
          vertical: 'bottom',
        },
        transformOrigin: {
          horizontal: 'right',
          vertical: 'top',
        },
      }}
      aria-label="Default answer"
      className={className}
      customRenderValue={selectedOption?.optionText ?? 'No default'}
      disabled={disabled}
      input={<ToolbarInput fullWidth open={selectOpen} />}
      menuAttribute="default-answer-menu"
      open={selectOpen}
      selectAttribute={Select.document.editor.rightDrawer.fieldDetailPanel.defaultAnswerSelect}
      spanAttribute="default-answer-span"
      value={value}
      onClose={() => setSelectOpen(false)}
      onOpen={() => setSelectOpen(true)}
      onSelectChange={e => {
        if (typeof e.target.value === 'string' || typeof e.target.value === 'number')
          onChangeAnswer(e.target.value);
      }}
    >
      <MenuItem value={''}>No default</MenuItem>
      {options.map((option, index) => {
        return (
          <MenuItem
            key={index}
            data-cy={Select.document.editor.rightDrawer.fieldDetailPanel.defaultAnswerSelectItem}
            value={option.id ?? index}
          >
            {option.optionText}
          </MenuItem>
        );
      })}
    </ToolbarSelect>
  );
}
